<script lang="ts">
	export let active = false;
	export let hover = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21.513">
	<g>
		<path
			class:hover
			class:active
			d="M700.268 151.126 697.5 143.4a1.792 1.792 0 0 0-1.682-1.187h-10.895a1.792 1.792 0 0 0-1.682 1.187l-2.765 7.729a1.785 1.785 0 0 0 1.682 2.386h.356v8.424a1.787 1.787 0 0 0 1.787 1.787h1.178a1.787 1.787 0 0 0 1.787-1.787v-4.89a.92.92 0 0 1 .917-.917h4.373a.92.92 0 0 1 .917.917v4.89a1.786 1.786 0 0 0 1.787 1.787h1.182a1.786 1.786 0 0 0 1.787-1.787v-8.424h.356a1.787 1.787 0 0 0 1.682-2.391zm-.93 1.135a.915.915 0 0 1-.752.387h-.791a.436.436 0 0 0-.435.435v8.859a.92.92 0 0 1-.917.917h-1.183a.92.92 0 0 1-.917-.917v-4.89a1.789 1.789 0 0 0-1.787-1.787h-4.373a1.789 1.789 0 0 0-1.787 1.787v4.89a.92.92 0 0 1-.917.917H684.3a.92.92 0 0 1-.917-.917v-8.859a.436.436 0 0 0-.435-.435h-.791a.9.9 0 0 1-.752-.387.917.917 0 0 1-.113-.839l2.765-7.729a.919.919 0 0 1 .865-.609h10.893a.919.919 0 0 1 .865.609l2.769 7.729a.917.917 0 0 1-.111.839z"
			transform="translate(-680.372 -142.215)" />
	</g>
</svg>

<style lang="scss">
	path {
		transition: all 0.5s;
		fill: #bcbfc3;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
